__turbopack_context__.v({
  "age": "BlockDetailPage-module__Y64b1G__age",
  "badge": "BlockDetailPage-module__Y64b1G__badge",
  "blockNumber": "BlockDetailPage-module__Y64b1G__blockNumber",
  "burntIcon": "BlockDetailPage-module__Y64b1G__burntIcon",
  "copyButton": "BlockDetailPage-module__Y64b1G__copyButton",
  "detailCard": "BlockDetailPage-module__Y64b1G__detailCard",
  "emptyIcon": "BlockDetailPage-module__Y64b1G__emptyIcon",
  "emptyState": "BlockDetailPage-module__Y64b1G__emptyState",
  "feeBreakdown": "BlockDetailPage-module__Y64b1G__feeBreakdown",
  "feeItem": "BlockDetailPage-module__Y64b1G__feeItem",
  "feeLabel": "BlockDetailPage-module__Y64b1G__feeLabel",
  "gasBar": "BlockDetailPage-module__Y64b1G__gasBar",
  "gasBarBlue": "BlockDetailPage-module__Y64b1G__gasBarBlue",
  "gasBarFill": "BlockDetailPage-module__Y64b1G__gasBarFill",
  "gasBarGreen": "BlockDetailPage-module__Y64b1G__gasBarGreen",
  "gasBarOrange": "BlockDetailPage-module__Y64b1G__gasBarOrange",
  "gasBarTrack": "BlockDetailPage-module__Y64b1G__gasBarTrack",
  "hashFull": "BlockDetailPage-module__Y64b1G__hashFull",
  "header": "BlockDetailPage-module__Y64b1G__header",
  "label": "BlockDetailPage-module__Y64b1G__label",
  "link": "BlockDetailPage-module__Y64b1G__link",
  "loading": "BlockDetailPage-module__Y64b1G__loading",
  "method": "BlockDetailPage-module__Y64b1G__method",
  "nav": "BlockDetailPage-module__Y64b1G__nav",
  "navButton": "BlockDetailPage-module__Y64b1G__navButton",
  "pageButton": "BlockDetailPage-module__Y64b1G__pageButton",
  "pageButtonActive": "BlockDetailPage-module__Y64b1G__pageButtonActive",
  "pagination": "BlockDetailPage-module__Y64b1G__pagination",
  "row": "BlockDetailPage-module__Y64b1G__row",
  "skeleton": "BlockDetailPage-module__Y64b1G__skeleton",
  "skeletonShimmer": "BlockDetailPage-module__Y64b1G__skeletonShimmer",
  "statusSuccess": "BlockDetailPage-module__Y64b1G__statusSuccess",
  "tab": "BlockDetailPage-module__Y64b1G__tab",
  "tabActive": "BlockDetailPage-module__Y64b1G__tabActive",
  "table": "BlockDetailPage-module__Y64b1G__table",
  "tableContainer": "BlockDetailPage-module__Y64b1G__tableContainer",
  "tabs": "BlockDetailPage-module__Y64b1G__tabs",
  "title": "BlockDetailPage-module__Y64b1G__title",
  "value": "BlockDetailPage-module__Y64b1G__value",
});
